export class CPhotoGalery {
    fId: number;
    fDataCreatedOn: string;
    fDateCreatedOnPersian: string;
    fDateLastUpdate: string;
    fDateLastUpdatePersian: string;
    fUserIdCreator: string;
    fUserIdEditor: string;
    fDescription: string;
    fImageAddressHighQuality: string;
    fImageAddressLowQuality: string;
    fPhotoGaleryGroupId: number;

    constructor() {
        this.fId = 0;
        this.fDataCreatedOn = '';
        this.fDateCreatedOnPersian = '';
        this.fDateLastUpdate = '';
        this.fDateLastUpdatePersian = '';
        this.fUserIdCreator = '';
        this.fUserIdEditor = '';
        this.fDescription = '';
        this.fImageAddressHighQuality = '';
        this.fImageAddressLowQuality = '';
        this.fPhotoGaleryGroupId = 0;
    }
}